import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_abe2d29f-124d-4d47-8ea5-00e2d8b6fffe/artifacts/c69327adea33bb89_CowboyApps%20New%20Logo%20%28500%20x%20300%20px%29_20261017_104602_0000.png";

export const TELEGRAM_URL = "https://t.me/cowboyapps";

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imgSrc = (p) =>
  !p ? "" : p.startsWith("http") ? p : `${API}/files/${p}`;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const getVisitorId = () => {
  let id = localStorage.getItem("ca_visitor_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("ca_visitor_id", id);
  }
  return id;
};

export const track = (type, appId = "") => {
  api.post("/track", { type, visitor_id: getVisitorId(), app_id: appId }).catch(() => {});
};
